// productData.js — données de démonstration + référentiels du module Produits.
// ⚠️ À l'intégration : remplace getDemoProducts() par tes données réelles
// (via props ou ton store). Les référentiels (CATS, UNITS…) doivent pointer
// vers tes endpoints /categories, /units, /warehouses, /taxes.

export const CATS = [
  { name: "Matériaux", ico: "layers" },
  { name: "Couverture", ico: "home" },
  { name: "Finitions", ico: "paint-roller" },
  { name: "Plomberie", ico: "pipette" },
  { name: "Quincaillerie", ico: "wrench" },
  { name: "Outillage", ico: "hammer" },
];

export const UNITS = [
  { name: "Sac", short: "sac" }, { name: "Unité", short: "u" },
  { name: "Mètre", short: "m" }, { name: "Barre", short: "barre" },
  { name: "Kilogramme", short: "kg" }, { name: "Litre", short: "L" },
  { name: "Tonne", short: "t" }, { name: "Pot", short: "pot" },
];

export const WHS = [
  { name: "Magasin Central", sub: "Quincaillerie du Faso" },
  { name: "Dépôt Zone 4", sub: "Ouagadougou" },
  { name: "Réserve Atelier", sub: "Arrière-boutique" },
];

export const TAXES = [
  { name: "Exonéré (0 %)", v: 0 },
  { name: "TVA 18 %", v: 18 },
];

export const shortFor = (unitName) =>
  (UNITS.find((u) => u.name === unitName) || {}).short || "";
export const nameForShort = (short) =>
  (UNITS.find((u) => u.short === short) || {}).name || short || "";

export function getDemoProducts() {
  const P = [
    { id: 1, name: "Ciment CIMFASO 50kg", code: "CIM-50", cat: "Matériaux", unit: "sac", stock: 240, alert: 30, sale: 4500, cost: 3800, bc: "6181100240015" },
    { id: 2, name: "Tôle bac aluminium 3m", code: "TOL-3M", cat: "Couverture", unit: "u", stock: 58, alert: 15, sale: 12000, cost: 9500, bc: "6181100580022" },
    { id: 3, name: "Peinture acrylique 20L", code: "PEI-20", cat: "Finitions", unit: "pot", stock: 9, alert: 12, sale: 28500, cost: 22000, bc: "6181100090039" },
    { id: 4, name: "Fer à béton Ø12 (barre 12m)", code: "FER-12", cat: "Matériaux", unit: "barre", stock: 0, alert: 20, sale: 6800, cost: 5400, bc: "6181100000046" },
    { id: 5, name: "Gravier concassé", code: "GRA-05", cat: "Matériaux", unit: "t", stock: 32, alert: 10, sale: 18000, cost: 14000, bc: "6181100320053" },
    { id: 6, name: "Colle carrelage 25kg", code: "COL-25", cat: "Finitions", unit: "sac", stock: 76, alert: 20, sale: 7200, cost: 5600, bc: "6181100760060" },
    { id: 7, name: "Tube PVC Ø100 — 4m", code: "PVC-100", cat: "Plomberie", unit: "u", stock: 120, alert: 30, sale: 3500, cost: 2400, bc: "6181101200077" },
    { id: 8, name: "Pointe 8cm", code: "PNT-08", cat: "Quincaillerie", unit: "kg", stock: 5, alert: 8, sale: 1500, cost: 1000, bc: "6181100050084" },
    { id: 9, name: "Brouette renforcée", code: "BRO-01", cat: "Outillage", unit: "u", stock: 14, alert: 5, sale: 32000, cost: 25000, bc: "6181100140091" },
    { id: 10, name: "Disque à meuler Ø230", code: "DIS-230", cat: "Outillage", unit: "u", stock: 0, alert: 12, sale: 2200, cost: 1500, bc: "6181102300108" },
  ];
  const matiere = new Set([1, 4, 5, 8]);
  const whById = { 1: "Magasin Central", 2: "Dépôt Zone 4", 3: "Magasin Central", 4: "Réserve Atelier", 5: "Dépôt Zone 4", 6: "Magasin Central", 7: "Magasin Central", 8: "Réserve Atelier", 9: "Dépôt Zone 4", 10: "Magasin Central" };
  P.forEach((p) => {
    p.type = matiere.has(p.id) ? "Matières premières" : "Produits finis";
    p.wh = whById[p.id] || "Magasin Central";
    p.tax = "TVA 18 %";
    p.stockMode = "standard";
    p.bcSymbol = "EAN13";
  });
  const byId = (id) => P.find((p) => p.id === id);
  Object.assign(byId(1), { desc: "Ciment Portland CPA 45 — sac de 50 kg. Prise rapide, usage structurel.", pk: { label: "Palette de 40 sacs", content: 40, price: 152000 } });
  Object.assign(byId(3), { tax: "Exonéré (0 %)", desc: "Peinture acrylique mate intérieure/extérieure, pot de 20 L." });
  byId(4).pk = { label: "Botte de 10 barres", content: 10, price: 54000 };
  byId(5).pk = { label: "Benne 6 tonnes", content: 6, price: 84000 };
  byId(7).stockMode = "pre_order";
  byId(8).pk = { label: "Carton de 25 kg", content: 25, price: 25000 };
  Object.assign(byId(9), { desc: "Brouette 100 L à roue gonflable, châssis renforcé." });
  return P;
}
